import styled from 'styled-components';

export const Help = styled.div`
  font-size: 1.4rem;
  margin-bottom: 0.8rem;
  color: var(--color-grayscale-light-slate);
  font-weight: 400;
`;

export const Error = styled.span`
  position: absolute;
  right: 0;
  bottom: -1.8rem;
  color: var(--color-error);
  font-family: Inter, sans-serif;
  font-size: 1rem;
  letter-spacing: -0.2px;
  text-align: right;
`;
